<template>
    <div class="modal fade" :class="{ 'is-open': open }">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">新增保障設定</h3>
                </div>
                <div class="modal-body">
                    <form class="form">
                       <div class="row">
                           <!-- API Type/Report Type -->
                            <div class="col-12">
                                <div class="form-group row">
                                  <label class="col-4 text-right" for="report">API Type/Report Type</label>
                                  <div class="col-8">
                                    <input class="form-control form-control-inline w-75" id="report" type="text" maxlength="20" v-model="formData.report"/>
                                  </div>
                                </div>
                            </div>
                            <!-- 保障設定名稱 -->
                            <div class="col-12">
                                <div class="form-group row">
                                  <label class="col-4 text-right" for="reportName">保障設定名稱</label>
                                  <div class="col-8">
                                      <input class="form-control form-control-inline w-75" id="reportName" type="text" maxlength="20" v-model="formData.report_name"/>                                    
                                  </div>
                                </div>
                            </div>
                            <!-- 資料階層數 -->
                            <div class="col-12">
                                <div class="form-group row">
                                    <label class="col-4 text-right" for="shellLevel">資料階層數</label>
                                    <div class="col-2">
                                      <select 
                                        class="form-control form-control-inline form-large w-100" 
                                        id="shellLevel" 
                                        v-model="formData.shell_level"
                                        @change="changeShellLevel"
                                      >
                                            <option value="0">0</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                        </select>  
                                    </div>
                                    <label class="col-6 text-secondary font-weight-normal" for="shellLevel">(不含中項保障群組層)</label>
                                </div>
                            </div>
                            <!-- 金額總計顯示 -->
                            <div class="col-12">
                                <div class="form-group row">
                                    <label class="col-4 text-right" for="sumPosition">金額總計顯示於</label>
                                    <div class="col-8">
                                      <div class="radio radio-inline ml-1">
                                        <input type="radio" id="sumPosition-0" v-model="formData.sum_position" value="0">
                                        <label for="sumPosition-0">中項保障</label>
                                      </div>
                                      <div class="radio radio-inline">
                                        <input type="radio" id="sumPosition-1" v-model="formData.sum_position" value="1" :disabled="formData.shell_level === '0'">
                                        <label for="sumPosition-1">最後一層(不含中項)</label>
                                      </div>
                                    </div>
                                </div>
                            </div>
                       </div> 
                    </form>
                </div>
                <div class="modal-footer">
                    <span v-if="hasWarning" class="text-red mr-3">注意！其他保障將無法設定</span>
                    <a @click="doClose()" class="btn btn-default mr-3">取消</a>
                    <a @click="doInsert()" class="btn btn-primary">確認</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { insertReport } from "@/service";

export default {
  name: "ReportAddModal",
  data() {
    return {
      formData: {
        report: "",
        report_name: "",
        shell: "",
        shell_level: "1",
        sum_position: "0",
        memo: "",
        status: "0",
        creator: "",
        creatorname: "",
      },
      userID: "",
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasWarning() {
      return this.formData.shell_level === "0" 
        || (this.formData.shell_level === "1" && this.formData.sum_position === "1");
    },
  },
  watch: {
    //當AddModal被打開時執行initData方法
    open: "initData",
  },
  methods: {
    /** 初始 */
    initData() {
      this.userID = this.$store.state.userInfo.id;
      this.formData.creator = this.$store.state.userInfo.id;
      this.formData.creatorname = this.$store.state.userInfo.name;
      this.formData.report = "";
      this.formData.report_name = "";
      this.formData.shell_level = "1";
      this.formData.sum_position = "0";
    },
    /** 新增保障內容設定 */
    async doInsert() {
      if (!this.formData.report) {
        this.$toast.info({ title: "請輸入API Type/Report Type" });
        return;
      }
      if (!this.formData.report_name) {
        this.$toast.info({ title: "請輸入保障設定名稱" });
        return;
      }
      if (!confirm("確認要新增保障設定?")) {
        return;
      }
      await insertReport(this.userID, this.formData).then((result) => {
        if (result.header && result.header.status == "200") {
          this.$toast.info({ title: "新增保障設定成功" });
          this.initData(); //清空資料
          this.$emit("confrim"); //重新讀取頁面
        } else if (result.header.status == "-2") {
          this.$toast.info({ title: "type：" + this.formData.report + "，已存在，不可重複新增" });
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    /** 關閉AddModal **/
    doClose() {
      this.$emit("close");
    },
    changeShellLevel() {
      if (this.formData.shell_level === "0") this.formData.sum_position = "0";
    }
  },
};
</script>

<style scoped>
.modal.fade .modal-body {
  min-height: auto;
}
</style>
